import {
    Col,
    Typography,
    message,
    Table,
    Row,
    Button,
  } from "antd";
  import { routes } from "common/routes";
  import { generateHeaders } from "common/utils";
import { AppPageHeader } from "components/AppPageHeader";
  import { useAppDispatch } from "hooks/useAppDispatch";
  import { useAppSelector } from "hooks/useAppSelector";
  import { useDocumentTitle } from "hooks/usePageTitle";
  import { useEffect, useMemo } from "react";
  import { useNavigate } from "react-router-dom";
import { cancelStoreReturn, removeProcessingStoreReturnMapping, saveStoreReturn } from "store/store-return/storeReturnUploadSlice";
  
  const MESSAGE_KEY = "SAVE_STORE_RETURN";
  
  const SaveStoreReturnPage = () => {
    useDocumentTitle("Save Store Return");
    const { processingStoreReturn, status, error } = useAppSelector(
      (state) => state.storeReturnUpload
    );
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
  
    useEffect(() => {
      const { timeUploaded } = processingStoreReturn;
      if (timeUploaded) {
        const uploadedTime = new Date(timeUploaded).getTime();
        const currentTime = new Date().getTime();
        const minsPassed = (currentTime - uploadedTime) / 1000 / 60;
  
        if (minsPassed >= 15) {
          dispatch(removeProcessingStoreReturnMapping());
        }
      }
  
      if (!Object.keys(processingStoreReturn).length) { 
        navigate(`/${routes.STORE_RETURN.UPLOAD}`);
      }
    }, [dispatch, processingStoreReturn, navigate]);
  
    useEffect(() => {
      if (status === "loading") {
        message.loading({ content: "saving store return", key: MESSAGE_KEY });
      } else if (status === "success") {
        message.success({
          content: "Store Return saved!",
          duration: 5,
          key: MESSAGE_KEY,
        });
      } else if (status === "cancelling") {
        message.loading({ content: "cancelling store return", key: MESSAGE_KEY });
      } else if (status === "error") {
        message.error({ content: error, key: MESSAGE_KEY });
      }
  
      return () => {
        message.destroy();
      };
    }, [status, error]);
  
    let content;
    const { headerMapping } = processingStoreReturn;
    const { Text } = Typography;
  
    const generateMemoizedHeaders = useMemo(
      () => generateHeaders(headerMapping),
      [headerMapping]
    );
  
    const onSaveRequisition = () => {
      dispatch(saveStoreReturn());
    };
  
    const onCancelSave = () => {
      dispatch(cancelStoreReturn());
    };
  
    if ((processingStoreReturn.success) === 0) {
      content = <Text>Nothing to show here!</Text>;
    } else {
      const headers = generateMemoizedHeaders || {};
      const successRows = processingStoreReturn.successRows;
      const data = successRows?.map((row, i) => ({ ...row, key: `data-${i}` }));
      const columns = [
        ...Object.keys(headers).map(
          (key) =>
            ({
              key,
              title: headers[key],
              dataIndex: key,
            } as any)
        ),
      ];
      content = (
        <Table
          size="small"
          columns={columns}
          dataSource={data}
          scroll={{ y: 500, x: "100vh" }}
          summary={() => (
            <Table.Summary fixed="bottom">
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={24}>
                  <Row>
                    <Col>
                      <Button
                        type="primary"
                        onClick={onSaveRequisition}
                        loading={status === "loading"}
                        disabled={status === "loading"}
                      >
                        Save Requisition
                      </Button>
                    </Col>
                    <Col style={{ justifyContent: "left", marginLeft: "20px" }}>
                      <Button
                        onClick={onCancelSave}
                        disabled={status === "loading"}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
        ></Table>
      );
    }
  
    return (
      <>
        <Row>
          <Col>
            <AppPageHeader title="Save Store Return Mapping" />
          </Col>
        </Row>
        <Row>
          <Col xs={24}>{content}</Col>
        </Row>
      </>
    );
  };
  
  export default SaveStoreReturnPage;